import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import BotaoNovoCadastro from '../../components/botao/BotaoNovoCadastro'
import Footer from '../../components/footer/Footer'
import ModalEditarCadastro from '../../components/modal/ModalEditarCadastro';
import { TbPencil } from "react-icons/tb";
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';
import Tabela from '../../components/Tabela';

function CategorizacaoEstrategicaDemanda() {
    const { CategoriasConsulta, modalEditarOpen, loading, ListaCategorizacaoConsulta, setModalEditar, setDemandaAtual, Success, Error, Permissao, ListaFiltroCategorizacao, totalRegistrosCategorizacao, filtroCategorizacao, totalRegistrosFiltroCategorizacao, AtualizarStatus } = useContext(ApiContext)
    const { h3Demanda, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCadastro = (props) => {
        setDemandaAtual(props)
        setModalEditar(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCategorizacao(searchTerm, currentPage, pageSize);
        } else {
            ListaCategorizacaoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCategorizacao : totalRegistrosCategorizacao;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <Header pagina={'Cadastros'} subpagina={'Categorização estratégica'}></Header>
            <MenuLateral></MenuLateral>
            <div className="container-principal">
                <div className="demanda-header">
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <BotaoNovoCadastro end="CategorizacaoEstrategicaDemanda" />
                    }
                    {modalEditarOpen &&
                        <ModalEditarCadastro end="CategorizacaoEstrategicaDemanda" currentPage={currentPage} />
                    }
                </div>
                <div className="card card-table">
                    <h3 className='h3-demanda' style={h3Demanda}>Categorização Estratégica da Demanda</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroCategorizacao : CategoriasConsulta}
                        columns={[
                            { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => AtualizarStatus("CategorizacaoEstrategicaDemanda", x.key, !x.ativo, currentPage)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditCadastro(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroCategorizacao(term, 1, 10);
                            } else {
                                ListaCategorizacaoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}

export default CategorizacaoEstrategicaDemanda;